import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type View = "search" | "certificate-detail" | "admin-login" | "admin" | "microsoft-callback" | "access-denied" | "dashboard" | "users" | "bachelor-degrees" | "master-degrees" | "language-certificates" | "awards" | "scholarship" | "scholarship-title"

interface ViewStore {
    currentView: View;
    setCurrentView: (view: View) => void;
    resetView: () => void;
    _hasHydrated: boolean;
    setHasHydrated: (state: boolean) => void;
}

const DEFAULT_VIEW: View = 'search';

export const useViewStore = create<ViewStore>()(
    persist(
        (set) => ({
            currentView: DEFAULT_VIEW,
            _hasHydrated: false,
            setCurrentView: (view: View) => set({ currentView: view }),
            resetView: () => set({ currentView: DEFAULT_VIEW }),
            setHasHydrated: (state: boolean) => set({ _hasHydrated: state }),
        }),
        {
            name: 'view-store',
            storage: createJSONStorage(() => sessionStorage),
            onRehydrateStorage: () => (state) => {
                if (state) {
                    state.setHasHydrated(true);
                }
            },
        }
    )
);

// Hook để check khi nào store đã load xong
export const useViewStoreHydration = () => {
    const _hasHydrated = useViewStore((state) => state._hasHydrated);
    return _hasHydrated;
};
